import $ from 'jquery';
// import config from './config.js';

const apiPath = process.env.VUE_APP_API || '';

let api_post = function ( api, data, callback ) {

    // if (config.log) console.log('call api: ', config.path.api + api);

    $.ajax( {
        url: apiPath + api,
        type: 'POST',
        dataType: 'JSON',
        data: data,
    } )
        .done( function ( res ) {
            if ( callback ) callback( res );
        } )
        .fail( function ( res ) {
            if ( callback ) callback( res );
        } );
};



let api_post_header = function ( api, header, data, callback ) {

    $.ajax( {
        url: apiPath + api,
        type: 'POST',
        headers: header,
        dataType: 'JSON',
        data: data,
    } )
        .done( function ( res ) {
            if ( callback ) callback( res );
        } )
        .fail( function ( res ) {
            if ( res.status === 403 || res.responseJSON.msg === "評測已結束" ) {
                localStorage.removeItem( "userData" );
                $.removeCookie( "SMA" );
                location.href = "/";
                alert( "評測已結束" );
            }
            if ( callback ) callback( res );
        } );
};




let api_get = function ( api, header ) {

    return new Promise( ( resolve, reject ) => {
        // if (config.log) console.log('call api: ', apiPath + api);

        $.ajax( {
            url: apiPath + api,
            type: 'GET',
            headers: header,
            // dataType: 'JSON',
        } )
            .done( function ( res ) {
                resolve( res );
            } )
            .fail( function ( res ) {
                if ( res.status === 403 || res.responseJSON.msg === "評測已結束" ) {
                    localStorage.removeItem( "userData" );
                    $.removeCookie( "SMA" );
                    location.href = "/";
                    alert( "評測已結束" );
                }
                reject( res );
            } );
    } );

};



let grouping_by_star = function ( data ) {

    if ( data == [] || data.length == 0 ) return [];

    let total = 20;
    let ary = [];

    for ( let i = total; i > 0; i-- ) {

        ary.push( { star: i, list: [] } );

        for ( let k in data ) {

            let d = data[ k ];

            if ( d.star == i ) {

                if ( d.star >= 10 ) ary[ total - i ].list.push( { name: d.name, picture: d.picture.data.full_url } );
                else ary[ total - i ].list.push( { name: d.name } );
            }
        }
    }

    return ary;
};

let grouping_by_month = function ( data ) {

    if ( data == [] || data.length == 0 ) return [];

    let ary = [];
    let month_format = [
        { title: [ '1月', 'JAN' ], list: [] },
        { title: [ '2月', 'FEB' ], list: [] },
        { title: [ '3月', 'MAR' ], list: [] },
        { title: [ '4月', 'APR' ], list: [] },
        { title: [ '5月', 'MAY' ], list: [] },
        { title: [ '6月', 'JUN' ], list: [] },
        { title: [ '7月', 'JUL' ], list: [] },
        { title: [ '8月', 'AUG' ], list: [] },
        { title: [ '9月', 'SEP' ], list: [] },
        { title: [ '10月', 'OCT' ], list: [] },
        { title: [ '11月', 'NOV' ], list: [] },
        { title: [ '12月', 'DEC' ], list: [] },
    ];

    for ( let k in month_format ) {
        ary.push( month_format[ k ] );
    }

    for ( let i in ary ) {

        let month = ary[ i ];

        for ( let u in data ) {

            if ( data[ u ].month === month.title[ 1 ] ) {

                if ( data[ u ].picture && data[ u ].title ) {
                    // 升Ｋ／升星
                    ary[ i ].list.push( { name: data[ u ].name, picture: data[ u ].picture.data.full_url, title: data[ u ].title } );
                }
                else if ( data[ u ].picture ) {
                    ary[ i ].list.push( { name: data[ u ].name, picture: data[ u ].picture.data.full_url } );
                }
                else ary[ i ].list.push( data[ u ].name );
            }
        }
    }

    return ary;
};

export default {
    get: api_get,
    post: api_post,
    post_header: api_post_header,
    month: grouping_by_month,
    star: grouping_by_star
};
